// Yandex Metrika integration.
// Counter id matches the snippet provided by the user.
export const YM_COUNTER_ID = 109204022

declare global {
  interface Window {
    ym?: ((...args: any[]) => void) & { a?: any[]; l?: number }
  }
}

const SCRIPT_SRC = 'https://mc.yandex.ru/metrika/tag.js?id=109204022'

// Initialize Yandex Metrika by injecting the official tag.js loader.
// Safe to call multiple times — duplicate injection is guarded.
export function initYandexMetrika(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Prevent duplicate loads (same guard as the official snippet).
  const scripts = document.scripts
  for (let j = 0; j < scripts.length; j++) {
    if (scripts[j].src === SCRIPT_SRC) return
  }

  // Bootstrap the ym() queue so calls before tag.js loads are buffered.
  const w = window as Window
  if (!w.ym) {
    const stub: any = function () {
      ;(stub.a = stub.a || []).push(arguments)
    }
    stub.l = +new Date()
    w.ym = stub
  }

  // Inject tag.js
  const k = document.createElement('script')
  const a = document.getElementsByTagName('script')[0]
  k.async = true
  k.src = SCRIPT_SRC
  a.parentNode?.insertBefore(k, a)

  // Init counter
  w.ym?.(YM_COUNTER_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  })
}

// Trigger a Metrika goal. Safe to call before tag.js loads — calls are queued.
export function reachGoal(
  target: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  try {
    if (typeof window.ym === 'function') {
      if (params) window.ym(YM_COUNTER_ID, 'reachGoal', target, params)
      else window.ym(YM_COUNTER_ID, 'reachGoal', target)
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[metrika] reachGoal failed', e)
  }
}
